<template>
  <div class="card card-small h-100">

    <!-- Card Header -->
    <div class="card-header border-bottom">
      <h6 class="m-0">{{title}}</h6>
    </div>

    <!-- Chart -->
    <div class="card-body d-flex py-0">
      <canvas height="220" ref="canvas" class="blog-users-by-device m-auto"></canvas>
    </div>

    <d-card-footer class="border-top">
      <d-row>

        <!-- Time Frame -->
        <!-- <d-col>
          <d-select size="sm" value="last-week" style="max-width: 130px;">
            <option value="last-week">Semana passada</option>
            <option value="today">Hoje</option>
            <option value="last-month">Mês passado</option>
            <option value="last-year">Ano passado</option>
          </d-select>
        </d-col> -->

        <!-- View Full Report -->
        <!-- <d-col class="text-right view-report">
          <a href="#">Relatório completo &rarr;</a>
        </d-col> -->

      </d-row>
    </d-card-footer>
  </div>
</template>

<script>
import Chart from '_utils/chart';

export default {
  name: 'tickets-stats',
  props: {
    /**
       * The chart config.
       */
    chartConfig: {
      type: Object,
      default() {
        return {};
      },
    },
    /**
       * The chart options.
       */
    chartOptions: {
      type: Object,
      default() {
        return {};
      },
    },
    /**
       * The chart data.
       */
    chartData: {
      type: Object,
      default() {
        return [];
      },
    },
    /**
       * The chart title.
       */
    title: {
      type: String,
      default: 'Chamados Visão geral',
    },
  },
  mounted() {
    const chartConfig = {
      type: 'pie',
      data: this.chartData,
      options: {
        ...{
          legend: {
            position: 'bottom',
            labels: {
              padding: 25,
              boxWidth: 20,
            },
          },
          cutoutPercentage: 0,
          tooltips: {
            custom: false,
            mode: 'index',
            position: 'nearest',
          },
        },
        ...this.chartOptions,
      },
    };

    new Chart(this.$refs.canvas, chartConfig);
  },
};
</script>
